import { render, staticRenderFns } from "./TheWelcomeHeader.vue?vue&type=template&id=49552e7e&scoped=true&"
import script from "./TheWelcomeHeader.vue?vue&type=script&lang=ts&"
export * from "./TheWelcomeHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TheWelcomeHeader.vue?vue&type=style&index=0&id=49552e7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49552e7e",
  null
  
)

export default component.exports